module.exports = __webpack_public_path__ + "img/enterprise-loans.44b241cf.png";